import React, { Component } from 'react';
import Table from '../components/CustomPages/Index'
import WebpackerReact from 'webpacker-react';

class CustomPageIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
            if (format.id === item.id) {
              return { ...item, 
                name: format.name,
                content: format.content,
                url: format.url,
              }
            }
            return item;
          })
        });
    }

    loadData = () => {
        fetch(`/settings/get_custom_pages`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                    url={this.props.url}
                    empresa={this.props.empresa}
                    estados={this.props.estados}
                />
            </React.Fragment>
        );
    }
}


export default CustomPageIndex;
WebpackerReact.setup({ CustomPageIndex });
